module.exports = __webpack_public_path__ + "img/efs_token.lh.a1ded93.png";